<script>
import Vue from "vue";
import { reactive, ref, watch, toRef } from "@vue/composition-api";
import axios from "@/assets/js/axios";
import qs from "qs";
import { Message, MessageBox } from "element-ui";
import { getBody, getError } from "./utils";
export default Vue.extend({
    setup(props, { emit }) {
        
        const mode = ref("4");
        const onTabClick = ({ name }) => {
            mode.value = name;
            if (name == "4" || name == "5") {
                onClear();
            }
        };

        const shoudongshuru = reactive({
            form: {
                text: "",
            },
            data: [],
        });
        const onShoudongAddClick = () => {
            try {
                if (!shoudongshuru.form.text.trim()) {
                    throw new Error();
                }
                const textArr = shoudongshuru.form.text.split(/[\n]/);
                // console.log(textArr);
                let totalNum = textArr.length;
                let errorNum = 0;
                textArr.forEach((element) => {
                    const splitList = element.trim().split("|");
                    let whatsApp = splitList[0];
                    let name = "";
                    if (splitList.length >= 3) {
                        name = splitList[1];
                    } else if (splitList.length == 2) {
                        name = splitList[1];
                    } else {
                        name = "";
                    }
                    shoudongshuru.data = shoudongshuru.data.concat([
                        { name, whatsApp, isVerify: false },
                    ]);
                });
                let resultTip = `共输入${totalNum}个收件人,成功${
                    totalNum - errorNum
                }个,错误${errorNum}个。`;
                MessageBox.alert(resultTip, "输入结果", {
                    confirmButtonText: "确定",
                    callback: () => {
                        shoudongshuru.form.text = "";
                    },
                });
            } catch {
                Message.warning("输入框不能为空");
            }
        };
        const on2TagClose = (index) =>
            (shoudongshuru.data = shoudongshuru.data
                .slice(0, index)
                .concat(shoudongshuru.data.slice(index + 1)));

        const excelImport = reactive({
            data: [],
        });
        const uid2Data = new Map();
        const onHttpRequest = (option) => {
            if (typeof XMLHttpRequest === "undefined") {
                return;
            }
            var xhr = new XMLHttpRequest();
            var action = option.action;
            if (xhr.upload) {
                xhr.upload.onprogress = function progress(e) {
                    if (e.total > 0) {
                        e.percent = (e.loaded / e.total) * 100;
                    }
                    option.onProgress(e);
                };
            }
            var formData = new FormData();
            if (option.data) {
                Object.keys(option.data).forEach(function (key) {
                    formData.append(key, option.data[key]);
                });
            }
            formData.append(option.filename, option.file, option.file.name);
            xhr.onerror = function error(e) {
                option.onError(e);
            };
            xhr.onload = function onload() {
                try {
                    const res = JSON.parse(xhr.response);
                    if (!res.isSuccess) {
                        Message.error(res.errorMessage);
                        return option.onError(getError(action, option, xhr));
                    }
                } catch {
                    null;
                }
                if (xhr.status < 200 || xhr.status >= 300) {
                    return option.onError(getError(action, option, xhr));
                }
                option.onSuccess(getBody(xhr));
            };
            xhr.open("post", action, true);
            if (option.withCredentials && "withCredentials" in xhr) {
                xhr.withCredentials = true;
            }
            var headers = option.headers || {};
            for (var item in headers) {
                // if (headers.hasOwnProperty(item) && headers[item] !== null) {
                if (headers[item] !== null) {
                    xhr.setRequestHeader(item, headers[item]);
                }
            }
            xhr.send(formData);
            return xhr;
        };
        const onUploadExcel = (res, file) => {
            const data = res.data.contacts;
            uid2Data.set(file.uid, {
                load: true,
                data,
            });
            excelImport.data = excelImport.data.concat(data);
            MessageBox.alert(res.data.info, "导入结果", {
                confirmButtonText: "确定",
                callback: () => {},
            });
        };
        const onFileClick = (file) => {
            const load = uid2Data.get(file.uid).load;
            if (!load) {
                excelImport.data = excelImport.data.concat(
                    uid2Data.get(file.uid).data
                );
                uid2Data.set(file.uid, {
                    ...uid2Data.get(file.uid),
                    load: true,
                });
            }
        };
        const onFileRemove = (file) => {
            const unit = uid2Data.get(file.uid).data[0];
            const length = uid2Data.get(file.uid).data.length;
            const index = excelImport.data.findIndex((item) => item === unit);
            if (index !== -1) {
                excelImport.data = excelImport.data
                    .slice(0, index)
                    .concat(excelImport.data.slice(index + length));
            }
            uid2Data.delete(file.uid);
        };

        const recipient = ref([]);

        watch([toRef(shoudongshuru, "data"),toRef(excelImport, "data")],([v2, v3]) => {
            const res = [];
            res.push(...v2);
            res.push(...v3);
            recipient.value = res;
        });

        const onClear = () => {
            shoudongshuru.data = [];
            excelImport.data = [];
            clueList.checked = [];
            archiveList.checked = [];
            linkmanList.checked = [];
            const keys = uid2Data.keys();
            for (const key of keys) {
                uid2Data.set(key, { ...uid2Data.get(key), load: false });
            }
        };

        const clearOne = (item, index) => {
            recipient.value.splice(index, 1);
            if (shoudongshuru.data.length > 0) {
                shoudongshuru.data = shoudongshuru.data.filter(
                    (ele) => ele.whatsApp !== item.whatsApp
                );
            }
            if (excelImport.data.length > 0) {
                excelImport.data = excelImport.data.filter(
                    (ele) => ele.whatsApp !== item.whatsApp
                );
            }
            if (clueList.checked.length > 0) {
                let isLastDel =
                    recipient.value
                        .map((ele) => ele.myClueKey)
                        .indexOf(item.myClueKey) == -1;
                if (isLastDel) {
                    clueList.checked = clueList.checked.filter(
                        (key) => key != item.myClueKey
                    );
                }
            }
            if (linkmanList.checked.length > 0) {
                linkmanList.checked = linkmanList.checked.filter(
                    (ele) => ele.tel !== item.whatsApp
                );
            }
        };

        //获取已勾选的联系人
        watch(() => recipient.value,(newVal, oldVal) => {
            // console.log(recipient.value);
            emit("onFinishSelect", recipient.value, clueList.checked);
        });
        //查看已勾选的联系人
        const dialogVisible = ref(false);

        // 我的线索
        const clueList = reactive({
            loading: false,
            data: [],
            checked: [],
            pageIndex: 1,
            totalItems: 0,
        });
        const searchTerms = reactive({
            type: 0,
            keyword: "",
            isContacts: true,
            isMarketing: false,
            sort: 0,
        });
        const getMyClue = async () => {
            try {
                clueList.loading = true;
                clueList.data = [];
                const res = await axios({
                    method: "POST",
                    url: Vue.prototype.$clueUrl + "/MyClue/GetMyClue",
                    data: {
                        ...searchTerms,
                        pageIndex: clueList.pageIndex,
                        pageSize: 50,
                    },
                });
                clueList.data = res.data.datas.filter(item => item.waCount != 0);
                clueList.totalItems = res.data.totalItems;
            } catch {
                clueList.data = [];
            } finally {
                clueList.loading = false;
            }
        };
        const pageIndexChange = (page) => {
            clueList.pageIndex = page;
            getMyClue();
        };
        const clueChoose = (value) => {
            clueList.checked = value;
            recipient.value = [];
            if (value.length == 0) {
                return false;
            }
            getContactsList(clueList.checked);
        };
        const getContactsList = async (myClueKey) => {
            try {
                const res = await axios.post(
                    `${Vue.prototype.$clueUrl}/MyClue/v3/GetContactsList`,
                    {
                        myClueKeys: myClueKey,
                        isWa: true,
                    }
                );
                res.data.forEach((ele) => {
                    ele.customerName = ele.companyName;
                    ele.whatsApp = ele.tel;
                });
                recipient.value = res.data;
            } catch {
                return null;
            }
        };

        // WhatsApp存档
        const archiveList = reactive({
            loading: false,
            data: [],
            checked: [],
            pageIndex: 1,
            totalItems: 0,
        });
        const getUserArchive = async () => {
            try {
                archiveList.loading = true;
                archiveList.data = [];
                const res = await axios({
                    method: "POST",
                    url: Vue.prototype.$marketUrl + "/WhatsApp/FindUserArchive",
                    data: {
                        pageIndex: archiveList.pageIndex,
                        pageSize: 20,
                    },
                });
                archiveList.data = res.data.datas;
                archiveList.totalItems = res.data.totalItems;
            } catch {
                archiveList.data = [];
            } finally {
                archiveList.loading = false;
            }
        };
        getUserArchive();
        const archiveChange = (page) => {
            archiveList.pageIndex = page;
            getUserArchive();
        };
        const chooseArchive = (value) => {
            archiveList.checked = value;
            recipient.value = [];
            getArchiveDetail(archiveList.checked);
        };
        const getArchiveDetail = async (archiveKey) => {
            try {
                const res = await axios.post(
                    Vue.prototype.$marketUrl + "/WhatsApp/ArchiveDetail",
                    archiveKey
                );
                recipient.value = res.data;
            } catch {
                return null;
            }
        };

        //联系人线索
        const linkmanList = reactive({
            loading: false,
            data: [],
            checked: [],
            pageIndex: 1,
            totalItems: 0,
        });
        const getLinkmanClue = async () => {
            try {
                linkmanList.loading = true;
                linkmanList.data = [];
                const res = await axios({
                    method: "POST",
                    url: Vue.prototype.$clueUrl + "/MyClue/GetContactsClue",
                    data: {
                        isPhone: true,
                        pageIndex: linkmanList.pageIndex,
                        pageSize: 20,
                    },
                });
                linkmanList.data = res.data.datas;
                linkmanList.totalItems = res.data.totalItems;
            } catch {
                linkmanList.data = [];
            } finally {
                linkmanList.loading = false;
            }
        };
        getLinkmanClue();
        const linkmanChange = (page) => {
            linkmanList.pageIndex = page;
            getLinkmanClue();
        };
        const chooseLinkman = (value) => {
            linkmanList.checked = value;
            let arr = [];
            value.forEach((ele) => {
                arr.push({
                    whatsApp: ele.tel,
                    name: ele.name,
                    customerName: ele.companyName,
                });
            });
            recipient.value = arr;
        };

        const url = window.location.href;
        const index = url.lastIndexOf("?");
        //再次群发(获取联系人)
        const againSendKey = qs.parse(url.slice(index + 1))["againSendKey"] || "";
        if (againSendKey) {
            (async () => {
                const res = await axios({
                    method: "GET",
                    url: Vue.prototype.$marketUrl + "/WhatsApp/CopyTask",
                    params: { eventKey: againSendKey }
                });
                if (res.isSuccess) {
                    recipient.value = res.data.contacts;
                }
            })();
        }

        const isClueMass = qs.parse(url.slice(index + 1))["isClueMass"] || "";
        const isContactMass = qs.parse(url.slice(index + 1))["isContactMass"] || "";
        const searchRecordKey = qs.parse(url.slice(index + 1))["searchRecordKey"] || "";
        //公司线索-WhatsApp群发
        if (isClueMass) {
            let clueKeyList = localStorage.getItem("clueKeyList").split(",");
            mode.value = "4";
            (async () => {
                await getMyClue();
                clueChoose(clueKeyList);
            })();
        } else {
            getMyClue();
        }
        //联系人线索-WhatsApp群发
        if (isContactMass) {
            let myContacts = JSON.parse(
                localStorage.getItem("myContacts")
            ).filter((ele) => ele.tel != "");
            let arr = [];
            myContacts.forEach((ele) => {
                arr.push({
                    whatsApp: ele.tel,
                    name: ele.name,
                    customerName: ele.companyName,
                });
            });
            recipient.value = arr;
        }
        //搜联系人WhatsApp-任务列表-WhatsApp群发
        if (searchRecordKey) {
            mode.value = "5";
            archiveList.checked = [searchRecordKey];
            getArchiveDetail([searchRecordKey]);
        }

        return {
            mode,
            onTabClick,
            clueList,
            searchTerms,
            getMyClue,
            pageIndexChange,
            clueChoose,
            getContactsList,
            archiveList,
            getUserArchive,
            archiveChange,
            chooseArchive,
            getArchiveDetail,
            linkmanList,
            getLinkmanClue,
            linkmanChange,
            chooseLinkman,
            shoudongshuru,
            onShoudongAddClick,
            on2TagClose,
            onHttpRequest,
            onUploadExcel,
            onFileClick,
            onFileRemove,
            recipient,
            onClear,
            clearOne,
            window,
            dialogVisible,
        };
    },
});
</script>

<template>
    <div class="content-step-1">
        <div style="display: flex; justify-content: center; width: 100%">
            <el-tabs :value="mode" @tab-click="onTabClick" class="step-1-tabs">
                <el-tab-pane name="4">
                    <template #label>
                        <div style="display: flex; align-items: center">
                            <span>我的线索</span>
                        </div>
                    </template>
                </el-tab-pane>
                <el-tab-pane name="5">
                    <template #label>
                        <div style="display: flex; align-items: center">
                            <span>WhatsApp存档</span>
                        </div>
                    </template>
                </el-tab-pane>
                <el-tab-pane name="6">
                    <template #label>
                        <div style="display: flex; align-items: center">
                            <span>联系人线索</span>
                        </div>
                    </template>
                </el-tab-pane>
                <el-tab-pane name="2">
                    <template #label>
                        <div style="display: flex; align-items: center">
                            <span>手动输入</span>
                        </div>
                    </template>
                </el-tab-pane>
                <el-tab-pane name="3">
                    <template #label>
                        <div style="display: flex; align-items: center">
                            <span>文件导入</span>
                        </div>
                    </template>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div style="height: calc(100% - 100px); display: flex; justify-content: center">
            <div v-show="mode === '2'" style="box-sizing: border-box; flex-shrink: 0; width: 100%; ">
                <div style="height: 100%">
                    <div style="box-sizing: border-box; height: 100%; display: flex; position: relative;">
                        <!-- 使用多行输入框 -->
                        <el-input type="textarea" v-model="shoudongshuru.form.text" style="width: 100%;height: 100%;" size="mini" placeholder="收件人格式例如：WhatsApp账号|收件人名称|;WhatsApp账号必填;一行一个收件人;" />
                        <el-button @click="onShoudongAddClick" type="primary" class="shibie" size="mini">识别</el-button>
                    </div>
                </div>
            </div>
            <div v-show="mode === '3'" style="box-sizing: border-box; flex-shrink: 0; width: 100%;  border: 1px #DDDDDD solid">
                <div style="height: 100%; padding: 0 10px;">
                    <p style="height: 32px;line-height: 32px;">
                        使用方法:
                    </p>
                    <p style="height: 32px;line-height: 32px;">
                        1. <el-link :underline="false" type="primary" href="https://crm.qixinerp.com/ossfile/%E7%BE%A4%E5%8F%91%E8%81%94%E7%B3%BB%E4%BA%BA%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx">下载 Excel </el-link>模板,按照模板格式填入收件人信息
                    </p>
                    <p style="height: 32px;line-height: 32px;">
                        2. 按照模板格式编辑Excel文件
                    </p>
                    <p style="height: 32px;line-height: 32px;">
                        3. 收件人个数限制500个
                    </p>
                    <p style="height: 32px;line-height: 32px;">
                        4. 上传文件
                    </p>
                    <div style="height: calc(100% - 320px); overflow-y: hidden">
                        <el-upload :http-request="onHttpRequest" :on-remove="onFileRemove" :on-preview="onFileClick" :on-success="onUploadExcel" action="https://crm.qixinerp.com/marketing/WhatsApp/ExcelExport" :headers="{ Authorization: 'Bearer ' + window.localStorage.getItem('token') }">
                            <el-button type="primary" size="mini">点击上传</el-button>
                        </el-upload>
                    </div>
                </div>
            </div>
            <!-- 我的线索 -->
            <div v-show="mode === '4'" v-loading="clueList.loading" style="box-sizing: border-box; flex-shrink: 0; width: 100%;  border: 1px #DDDDDD solid">
                <div style="height: 40px; padding-left: 20px; display: flex; align-items: center">
                    <el-select v-model="searchTerms.type" placeholder="请选择" style="width:120px;" size="mini">
                        <el-option label="联系人名称" :value="0"></el-option>
                        <el-option label="联系人邮箱" :value="1"></el-option>
                        <el-option label="公司名称" :value="2"></el-option>
                        <el-option label="电话" :value="3"></el-option>
                        <el-option label="网址" :value="4"></el-option>
                        <el-option label="法人" :value="5"></el-option>
                    </el-select>
                    <el-input placeholder="搜索关键字" prefix-icon="el-icon-search" v-model="searchTerms.keyword" style="width:200px;" size="mini"></el-input>
                    <el-button type="primary" plain @click="pageIndexChange(1)" style="margin-left:10px;" size="mini">搜 索</el-button>
                </div>
                <div style="height: calc(100% - 40px); overflow-y: auto">
                    <div class="item-step-4">
                        <el-checkbox-group v-model="clueList.checked" @change="clueChoose">
                            <el-checkbox v-for="item of clueList.data" :key="item.key" :label="item.key">
                                <div style="color: #1F2D3D;font-weight: bold;">{{ item.companyName }}</div>
                                <div style="display: flex;justify-content: space-between;">
                                    <div style="color: #919191;">{{ item.officialWebsite }}</div>
                                    <div style="color: #3a3a3a">
                                        共<span style="padding:0 5px;color:var(--themeColor);">{{ item.waCount }}</span>个WhatsApp
                                    </div>
                                </div>
                            </el-checkbox>
                        </el-checkbox-group>
                        <el-pagination small :hide-on-single-page="true" :page-size="50" background layout="total,prev,pager,next" :total="clueList.totalItems" style="float:right;margin:0 5px;" :current-page.sync="clueList.pageIndex" @current-change="pageIndexChange"></el-pagination>
                    </div>
                </div>
            </div>
            <!-- WhatsApp存档 -->
            <div v-show="mode === '5'" v-loading="archiveList.loading" style="box-sizing: border-box; flex-shrink: 0; width: 100%;  border: 1px #DDDDDD solid">
                <div style="height: calc(100% - 30px); overflow-y: auto">
                    <div class="item-step-4">
                        <el-checkbox-group v-model="archiveList.checked" @change="chooseArchive">
                            <el-checkbox v-for="item of archiveList.data" :key="item.key" :label="item.key">
                                <div style="color: #1F2D3D;font-weight: bold;">{{ item.keyword }}</div>
                                <div style="display: flex;justify-content: space-between;">
                                    <div style="color: #919191;">{{ item.searchType }}</div>
                                    <div style="color: #3a3a3a">
                                        共<span style="padding:0 5px;color:var(--themeColor);">{{ item.phoneNumber }}</span>个WhatsApp
                                    </div>
                                </div>
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <el-pagination small :hide-on-single-page="true" :page-size="20" background layout="total,prev,pager,next" :total="archiveList.totalItems" style="float:right;margin:0 5px;" :current-page.sync="archiveList.pageIndex" @current-change="archiveChange"></el-pagination>
            </div>
            <!-- 联系人线索 -->
            <div v-show="mode === '6'" v-loading="linkmanList.loading" style="box-sizing: border-box; flex-shrink: 0; width: 100%;  border: 1px #DDDDDD solid">
                <div style="height: calc(100% - 30px); overflow-y: auto">
                    <div class="item-step-4">
                        <el-checkbox-group v-model="linkmanList.checked" @change="chooseLinkman">
                            <el-checkbox v-for="item of linkmanList.data" :key="item.key" :label="item">
                                <div style="color: #1F2D3D;font-weight: bold;">{{ item.name }}({{ item.tel }})</div>
                                <div style="display: flex;justify-content: space-between;">
                                    <div style="color: #919191;">{{ item.country }}</div>
                                </div>
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <el-pagination small :hide-on-single-page="true" :page-size="20" background layout="total,prev,pager,next" :total="linkmanList.totalItems" style="float:right;margin:0 5px;" :current-page.sync="linkmanList.pageIndex" @current-change="linkmanChange"></el-pagination>
            </div>
        </div>
        <div style="height: 46px;padding: 10px 20px;box-sizing: border-box; font-size:14px;display: flex;justify-content: space-between;align-items: center; cursor: pointer;" @click="dialogVisible = true;">
            <div>已选择<span style="padding:0 5px;font-size:18px;color:var(--themeColor);">{{recipient.length}}</span>个联系人</div>
            <div style="color:var(--themeColor);">查看</div>
        </div>

        <el-dialog title="收件人预览" :visible.sync="dialogVisible" width="500px" top="5vh">
            <div class="recipientBox">
                <div class="recipientItem" v-for="(item, index) of recipient" :key="item.whatsApp">
                    <p><span style="color: #1F2D3D">{{ item.name }}</span> &lt;{{ item.whatsApp }}&gt;</p>
                    <div v-if="item.isVerify">
                        <i class="el-icon-success" style="color: #67C23A"></i>
                        <span style="margin-left: 5px">已验证</span>
                    </div>
                    <div v-else style="color:#9C9C9C ;">未验证</div>
                    <i class="el-icon-circle-close" @click="clearOne(item, index)"></i>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="onClear" size="small" icon="el-icon-delete">清 空</el-button>
                <el-button @click="dialogVisible = false" size="small">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<style scoped lang="scss">
.mode---1 {
    ::v-deep
        .el-table--enable-row-hover
        .el-table__body
        tr:hover
        > td.el-table__cell {
        background: #e4eaef !important;
    }
}

.content-step-1 {
    box-sizing: border-box;
    height: 100%;
    padding: 0;
    position: relative;
}

.step-1-tabs {
    ::v-deep .el-tabs__nav-wrap::after {
        display: none;
    }
}

::v-deep .el-form--inline {
    .el-form-item {
        margin-bottom: 0;
    }
}

.item-step-1,
.item-step-4,
.mode---1 {
    margin: 0 10px;
    padding: 10px;
    overflow: hidden;

    ::v-deep .el-checkbox {
        display: flex;
        align-items: center;
        height: 40px;
        font-size: 14px;
        padding-left: 10px;
        border-bottom: 1px solid #e0e6ed;
        margin-bottom: 10px;
        padding-bottom: 10px;
        margin-right: 0;
        margin-left: 0;

        .el-checkbox__label {
            width: 100%;
        }
    }
}

::v-deep .el-dialog__body {
    padding: 0;
}

::v-deep .el-textarea__inner {
    height: 100%;
}

.shibie {
    flex-shrink: 0;
    height: 28px;
    margin-left: 15px;
    position: absolute;
    right: 0;
    bottom: 0;
}

.recipientBox {
    box-sizing: border-box;
    width: 100%;
    height: 600px;
    width: 500px;
    overflow-y: auto;
    .recipientItem {
        padding: 10px 20px;
        border-bottom: 1px solid #e0e6ed;
        color: #9c9c9c;
        font-size: 14px;
        position: relative;
        p {
            height: 20px;
        }
        .el-icon-circle-close {
            display: none;
            cursor: pointer;
            position: absolute;
            right: 20px;
            top: 20px;
        }
        &:hover .el-icon-circle-close {
            display: inline-block;
        }
    }
}
</style>
